// extracted by mini-css-extract-plugin
export default {"host":"TimeInput_host__CW0Vz","footerSpan":"TimeInput_footerSpan__KUoh1"};